// source: buying/achievement_tickets/types/v1/types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.buying.achievement_tickets.types.v1.AchievementBadgeType', null, global);
goog.exportSymbol('proto.buying.achievement_tickets.types.v1.AchievementTicketType', null, global);
/**
 * @enum {number}
 */
proto.buying.achievement_tickets.types.v1.AchievementTicketType = {
  ACHIEVEMENT_TICKET_TYPE_INVALID: 0,
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  I: 9
};

/**
 * @enum {number}
 */
proto.buying.achievement_tickets.types.v1.AchievementBadgeType = {
  ACHIEVEMENT_BADGE_TYPE_INVALID: 0,
  TOP_TRIVIA_JAPAN: 1,
  TOP_TRIVIA_FRANCE: 2,
  TOP_TRIVIA_US: 3,
  TECHNOLOGY_SONY: 4,
  TECHNOLOGY_NINTENDO: 5,
  TECHNOLOGY_YAMAHA: 6,
  ANIMATION_ANIME: 7,
  ANIMATION_MANGA: 8,
  ANIMATION_ANIMATED_FILM: 9,
  STYLE_AESTHETICS: 10,
  STYLE_STREET: 11,
  STYLE_FASHION: 12,
  ART_MOVEMENT_IMPRESSIONISM: 13,
  ART_MOVEMENT_CUBISM: 14,
  ART_MOVEMENT_SURREALISM: 15,
  FASHION_HOUSE_SAINT_LAURENT: 16,
  FASHION_HOUSE_BALENCIAGA: 17,
  FASHION_HOUSE_MAISON_MARGIELA: 18,
  UN_VOYAGE_EN_FRANCE_LE_SUD: 19,
  UN_VOYAGE_EN_FRANCE_PARIS: 20,
  UN_VOYAGE_EN_FRANCE_LEST: 21,
  SPORTS_BASKETBALL: 22,
  SPORTS_BASEBALL: 23,
  SPORTS_SKATEBOARDING: 24,
  FOOD_AMERICAN_ITALIAN: 25,
  FOOD_AMERICAN_TACO: 26,
  FOOD_AMERICAN_BURGER: 27,
  POP_CULTURE_MUSIC: 28,
  POP_CULTURE_TELEVISION: 29,
  POP_CULTURE_HOLLYWOOD: 30
};

goog.object.extend(exports, proto.buying.achievement_tickets.types.v1);
